import Vue from "vue";

// Currency redenomination ("remove two zeros"). Amounts are STORED (and sent to
// the backend / payment gateways) in the OLD unit; we divide by 100 only for
// display, always with 2 decimals so fractional new pounds are not dropped and
// totals reconcile. Returns "—" for null/empty.
//
// IMPORTANT: apply ONLY to monetary fields. Do NOT use on percentages
// (*_percentage, voucher.amount when discount_type === 'PERCENTAGE'), counts
// (use_times, max_redemption, totals of trips/users), times, or engine settings
// (EXCHANGE_RATE, CAPTAIN_MAX_NEGARIVE_AMOUNT).
export function formatMoney(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (isNaN(n)) return "—";
  return new Intl.NumberFormat("en", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n / 100);
}

// Convert a user-entered NEW-unit amount back to the OLD storage unit before
// POSTing to the backend (which stores/validates in old units). Pair EVERY
// money input with this. Preserves sign. Returns null for empty input.
export function toStoredAmount(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  if (isNaN(n)) return null;
  return Math.round(n * 100);
}

// `{{ value | money }}` in templates; `this.formatMoney(v)` / `this.toStoredAmount(v)` in code.
Vue.filter("money", formatMoney);
Vue.mixin({ methods: { formatMoney, toStoredAmount } });
